var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { unpackProfile, unpackProfileEmailData } from "../user/user.mapper";
import { UIModelHubProfile } from "../auth/auth.model";
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { MPInstanceAuthX360 } from "@/api/RequestAxios/RequestAxiosAuthX360";
import { UIModelProfile } from "../user/user.model";
import config from "@/config";
var profileUrl = function () { return "/user_profile"; };
var emailVerificationUrl = function () { return "/email_verified"; };
var requestVerificationUrl = function () {
    return "/send_verification_email?app_name=".concat(config.appName);
};
//TODO: The old endpoint for getting the profile of the current user has been left temporarily, because the new one does not have the otp_status field.
// Delete after BE adds this field to the response from the new endpoint
var oldProfileUrl = function () { return "/profile"; };
export var getAdminProfile = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.get(profileUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelHubProfile(unpackProfile(data))];
        }
    });
}); };
export var updateProfile = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(oldProfileUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelProfile(unpackProfile(data))];
        }
    });
}); };
//TODO: Delete after BE adds this field to the response from the new endpoint
export var getOldAdminProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(oldProfileUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getEmailVerification = function (options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = options.bypassCache
                        ? "".concat(emailVerificationUrl(), "?bypass_cache=true")
                        : emailVerificationUrl();
                    return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.get(url)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, unpackProfileEmailData(data)];
            }
        });
    });
};
export var requestVerificationEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.post(requestVerificationUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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